import { mapActions, mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters(["collecteById"]),
    collecteLoad() {
      if (this.collecte && Object.keys(this.collecte).length) return true
      else return false
    },
    collecteUnLoad() {
      return this.collecteLoad === false
    },
    identifiantCollecte() {
      return this.$route.params.identifiantCollecte
    },
    collecte() {
      return this.collecteById(this.identifiantCollecte)
    },
  },
  methods: {
    ...mapActions(["chargerCollecte"]),
    chargerCollecteEnCours() {
      this.chargerCollecte({ identifiantCollecte: this.identifiantCollecte, forceRefresh: this.$route.query.forceRefresh })
        .then(() => {
          if (this.collecte.nonDisponible) {
            this.$router.push({ name: "ErreurCollecte" })
          }
          if (this.$route.query.forceRefresh) {
            this.$router.replace({ query: { lang: this.$route.query.lang } })
          }
        })
        .catch(() => {
          this.$router.push({ name: "ErreurCollecte" })
        })
    }
  }
}